import React from "react"
import PropTypes from "prop-types"
import HistoricalAccessToolAction from "./HistoricalAccessToolAction"

const HistoricalAccessToolPreviousActions = ({ actions }) => (
  <>
    <h2 className="tab-title mt-0">Previous Actions</h2>
    {actions.sort((a, b) => (a.id < b.id ? 1 : -1)).map((action) => (
      <HistoricalAccessToolAction action={action} key={action.id} />
    ))}
  </>
)

HistoricalAccessToolPreviousActions.propTypes = {
  actions: PropTypes.array.isRequired,
}

export default HistoricalAccessToolPreviousActions
